import React from "react";
import styled from "styled-components";

// Styles
import { colors } from "../../../styles/colors";

export const FeaturesWithBox = () => {
  return (
    <StyledDivRootContainer>
      <StyledImgMainContent src={require("../../../assets/images/features.png")} />
    </StyledDivRootContainer>
  );
};

const StyledDivRootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${colors.logo_green__low_opacity};
`;

const StyledImgMainContent = styled.img`
  width: 80%;
  margin: 32px 0px;
`;
